import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ItemView from '../utils/ItemView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';
import { Link } from 'react-router-dom';

class GoodsDetailApp extends React.Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            ty: 4,
            gi: this.props.match.params["id"] || "",
            list: []
        };
        this.getData();
        this.onItemViewUpdated = this.onItemViewUpdated.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    getData() {
        var tmpData = {
            ty: this.state.ty,
            gi: this.state.gi
        };
        API.GetGoods(tmpData, this.onDataUpdated.bind(this));
    }

    onItemViewUpdated(index, value) {
        console.log(index, value);
        let list = Object.assign({}, this.state.list);
        list[index].data.value = value;
        this.setState({ list: list });
    }

    onSave() {
        console.log("onSave");
        const list = this.state.list;
        const header = {
            ty: 2, //功能(0=新增, 1=預覽, 2=修改)
            gi: this.state.gi
        };
        const body = {
            "point": list[1].data.value,       //所需點數,
            "type": list[2].data.value,        // 兌換類型(0=抽獎, 1=點數兌換, 2=現⾦金金點數換購), 
            "cash_point": list[3].data.value,  //所需現⾦金金點,
            "name": list[4].data.value,        //"商品名稱",
            "goods_num": list[5].data.value,   //商品數量量,
            "start_at": list[6].data.value,    //起始時間(Timemillis), 
            "goods_remain": list[7].data.value,      //禮物剩餘數量
            "end_at": list[8].data.value,      //結束時間(Timemillis),
            "max_roll": list[9].data.value,    //每⼈人最多兌換次數,
            "recv_type": list[10].data.value,   //領取⽅方式(0=純序號, 1=連結及通⾏行行碼), 
            "g_type": list[11].data.value,      //商品類型,
            "is_top": list[12].data.value,      //(0/1)是否置頂,
            "source": list[13].data.value,      //"委託業主",
            "is_recom": list[14].data.value,    //(0/1)是否推薦,
            "is_del": list[15].data.value,      //(0/1)是否刪除,
            "description": list[16].data.value, //"商品敘述", 
            // "": list[17].data.value,      //建立時間
            // "": list[18].data.value,      //建立人員
            // "": list[19].data.value,      //更新時間

            "icon": list[20].data.value,        //"圖⽰示連結",
            "images": list[21].data.value.split(","),      //["圖片組連結"],
            // "roll_at": list[22].data.value,     //type0: 抽獎時間(Timemillis)
            // "max_people": list[22].data.value,  //type0: 最多抽獎⼈人數,
        };
        console.log(header, body);
        let tmpThis = this;
        API.AddGood(header, body, function (res) {
            console.log(res);
            if (22000 == res.code) {
                alert("更新成功");
                tmpThis.props.history.go(0);
            }
        });
    }

    onDataUpdated(data) {
        console.log(this);
        if (data && data.data) {
            console.log(data);
            /* {
                "end_at": "1577721600000",
                "images": [
                    "gifts/261/z1s8lda25fzfbsnbona79qfw1j6nufcm.jpg"
                ],
                "is_recom": "0",
                "gid": "GE181211172613",
                "g_type": "0",
                "icon": "gifts/261/ws8ij2ywltrntsvy38xn1ki9qrfvehqt.jpg",
                "description": "►獎品介紹：7-11購物金35元。 \n►領獎方式：憑序號可免費獲得乙份7-ELEVEN 35元商品抵用券，自由兌換店內商品。\n►兌換方式（可任選一種方式兌換）：\n1.下載ibon行動生活站 APP→好康紅利→i禮贈→輸入12碼序號→閱讀兌換須知→至門市櫃檯出示條碼兌換。 \n2.請至門市ibon選擇好康/紅利→好康活動→i禮贈序號補卷→閱讀兌換須知→輸入12碼序號→列印紙本小白單卷後，持卷至門市櫃檯兌換 \n3.詳細兌換方式請參考:http://goo.gl/Fj1Afl \n►電子禮卷使用注意事項： \n1.本卷使用問題請洽智慧時尚客服中心：02-2377-6966。服務時間：周一至周五上午10:00至下午6:00。\n2.請於禮卷使用期限前至7-11門市兌換完畢，逾期恕無法使用及補發。 \n3.使用時須符合本載明之品牌與規格。商品兌換完成後，恕無法提供退貨及換貨。因各門市實際販售商品不同、兌換商品數量有限，若該門市已無存貨請至鄰近其他7-ELEVEN門市兌換。 \n4.不適用非開立7-ELEVEN發票之特殊門市 （如：台鐵門市、部分學校、廠辦及商場門市）與離島門市，請至鄰近其他門市兌換。 \n5.本卷不得折抵現金,現金抵用卷恕不找零。 \n6.本卷不可與其他行銷活動合併使用。也不計入7-ELEVEN舉辦之全店集點活動消費金額內。 \n7.本卷與兌換卷應妥善保管，若被盜用、損毀、遺失或因為保存不當造成模糊無法辨識而無法兌換，恕無法補發。 \n8.本卷不得使用代收、代售業務及健康捐商品（如：香菸）及儲值（如：icash、悠遊卡等）。",
                "created_at": "1544520373814",
                "max_roll": "0",
                "source": "dataa",
                "start_at": "1544371200000",
                "type": "1",
                "goods_remain": "500",
                "point": "35",
                "is_top": "0",
                "created_id": "admin",
                "updated_at": "1544520373814",
                "recv_type": "0",
                "is_del": "0",
                "name": "7-11購物金35元",
                "goods_num": "500",
                "cash_point": "0",
                "updated_id": "admin"
            } */
            const tmpObj = data.data[0];
            const tmp = [{
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: "禮物編號",
                    value: tmpObj.gid
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "E幣",
                    value: tmpObj.point
                }
            }, {
                type: Enums.E_ITEM.OPTION,
                data: {
                    label: "禮物類型",
                    value: tmpObj.type,
                    options: [
                        [0, "抽獎"],
                        [1, "點數兌換"],
                        [2, "現⾦金金點數換購"]
                    ]
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "金幣",
                    value: tmpObj.cash_point
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                data: {
                    label: "禮物名稱",
                    value: tmpObj.name
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: "禮物數量",
                    value: tmpObj.goods_num
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: "上架日期",
                    value: tmpObj.start_at
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "禮物剩餘數量",
                    value: tmpObj.goods_remain
                }
            }, {
                type: Enums.E_ITEM.TIME,
                data: {
                    label: "下架日期",
                    value: tmpObj.end_at
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "兌換次數限制",
                    value: tmpObj.max_roll
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                data: {
                    label: "兌換類型",
                    value: tmpObj.recv_type
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "商品類型",
                    value: tmpObj.g_type
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "置頂",
                    value: tmpObj.is_top
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: "委託業主",
                    value: tmpObj.source
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "強力推薦",
                    value: tmpObj.is_recom
                }
            }, {
                type: Enums.E_ITEM.NUMBER,
                col: 1,
                data: {
                    label: "刪除",
                    value: tmpObj.is_del
                }
            }, {
                type: Enums.E_ITEM.TEXTAREA,
                col: 1,
                data: {
                    label: "禮物說明",
                    value: tmpObj.description
                }
            }, {
                type: Enums.E_ITEM.TIME,
                col: 1,
                data: {
                    label: "建立時間",
                    value: tmpObj.created_at
                }
            }, {
                type: Enums.E_ITEM.TEXT,
                col: 1,
                data: {
                    label: "建立人員",
                    value: tmpObj.created_id
                }
            }, {
                type: Enums.E_ITEM.TIME,
                col: 1,
                data: {
                    label: "更新時間",
                    value: tmpObj.updated_at
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: "禮物主圖",
                    value: tmpObj.icon
                }
            }, {
                type: Enums.E_ITEM.IMAGE,
                data: {
                    label: "禮物副圖",
                    value: tmpObj.images.join(",")
                }
            }
            ];

            if (0 == tmpObj.type) {
                tmp.push({
                    type: Enums.E_ITEM.TIME,
                    data: {
                        label: "開獎日期",
                        value: tmpObj.roll_at
                    }
                });
                tmp.push({
                    type: Enums.E_ITEM.NUMBER,
                    data: {
                        label: "最多抽獎人數",
                        value: tmpObj.max_people
                    }
                });
            } else {
            }

            this.setState({
                list: tmp,
                type: tmpObj.type
            })
        }
    }

    onDelete() {
        console.log("onDelete");
        alert("沒有delete api");
    }

    render() {
        const { list, type, gi } = this.state,
            { onItemViewUpdated, onSave } = this;

        return (
            <div>
                <ItemView
                    title={"禮物:" + gi}
                    onUpdate={onItemViewUpdated}
                    onSave={onSave}
                    data={list}
                    enabled={false}
                    disablePreview={true}
                    disableDelete={true} />
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            {(0 == type) ? (<Link className="btn btn-outline-info" to={"/goods/record_lottery/" + gi}>所有抽獎名單</Link>) : (<Link className="btn btn-outline-info" to={"/goods/record_redeem/" + gi}>所有兌換名單</Link>)}
                        </div>
                        <div className="col-12 col-sm-6">
                            <button className="btn btn-outline-info" disabled onClick={function () { alert("抽獎api怪怪der...還沒做介面"); }}>抽獎</button>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(GoodsDetailApp),
//     document.getElementById('root')
// );
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GoodsDetailApp))